var map = {
	"./avispace/app/shared/results-back-button/results-back-button.component": [
		47640,
		[
			"default-src_app_shared_results-back-button_results-back-button_component_ts",
			"src_themes_avispace_app_shared_results-back-button_results-back-button_component_ts"
		]
	],
	"./custom/app/shared/results-back-button/results-back-button.component": [
		34681,
		[
			"default-src_app_shared_results-back-button_results-back-button_component_ts",
			"src_themes_custom_app_shared_results-back-button_results-back-button_component_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 79086;
module.exports = webpackAsyncContext;